/*
* Radio Button UI Switcher
*
* Uses radio button input as switcher of corresponding UI element.
* pages: Become A Dealer
**/

custom.radioUiSwitcher = (() => {

	let actions = {}; // Events store

	const switchClass = "radio-ui-switcher__switch";
	const activeClass = "radio-ui-switcher-active";


	// Subscribe to events
	function on(evt=null,callback=()=>{}) {
			if(!evt || !callback || typeof callback !== 'function') return;
			actions[evt] = actions[evt] || [];
			return actions[evt].push(callback);
	}

	// Trigger events
	function trigger(evt=null,payload={}) {
			if(!evt || !actions[evt]) return;
			return actions[evt].forEach(fn => fn(payload));
	}

	function toggleActiveClass(id=null) {
		$("[data-radio-ui-id]").removeClass(activeClass);
		$(`[data-radio-ui-id='${id}']`).addClass(activeClass);
	}

	function applyHeightToParentNode(id=null) {
		const hgt = $(`[data-radio-ui-id='${id}']`).outerHeight();
		$(`[data-radio-ui-id='${id}']`).parent().css('minHeight', hgt);
	}

	function scrollToTarget(id=null) {
		const newScrollPos = $(`[data-radio-ui-id='${id}']`).parent().offset().top;
		window.scrollTo({
			top: newScrollPos,
			behavior: 'smooth'
		});
		if($(`[data-radio-ui-id='${id}']`).find('input')) setTimeout(() => {$(`[data-radio-ui-id='${id}']`).find('input').focus();}, 600);
	}

	function uiSwitcher(event=null) {
		const targetId = $(event.target).val();
		const scrolling = $(event.target).data('radio-ui-scroll');

		toggleActiveClass(targetId);
		applyHeightToParentNode(targetId);
		if(scrolling) scrollToTarget(targetId);
	}

	function init() {
		const $switches = $(`.${switchClass}`).find("input[type='radio']");
		$switches.on('change', uiSwitcher);
	}

	return {
 		init,
		on,
		trigger
	}

})();

custom.radioUiSwitcher.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/radio-ui-switcher.js